import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import { blue } from "@mui/material/colors";

type Config = {
  [key: string]: boolean;
};

type Props = {
  config: Config;
  handleConfigChange: (e: React.ChangeEvent<HTMLInputElement>, value: boolean) => void;
};

export function IframeModeCheckbox({
  config,
  handleConfigChange,
}: Props) {
  return (
    <div>
      <FormLabel>
        Iframe mode
        <Checkbox
          checked={config.iFrameMode}
          name="iFrameMode"
          onChange={handleConfigChange}
          sx={{
            color: blue[800],
            "&.Mui-checked": {
              color: blue[600],
            },
          }}
        ></Checkbox>
      </FormLabel>
    </div>
  );
}
